import React from 'react';
import { motion } from 'framer-motion';
import type { RatingTally } from '../../../types/pulse';
import { ratingResult } from '../../../data/pulse';
import { ratingAlignmentNote, ratingStats } from '../../../utils/pulse';
import { AnswerRecap } from '../AnswerRecap';
interface RatingResultScreenProps {
  value: number;
  tally: RatingTally;
  /** The question being reported back, shown small for context. */
  context: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function RatingResultScreen({
  value,
  tally,
  context
}: RatingResultScreenProps) {
  const {
    average,
    highPct
  } = ratingStats(tally);
  return <div className="flex flex-1 flex-col" data-id="element-277" data-mp="knkyt73rblng">
      <p className="text-[11px] leading-snug text-mut" data-id="element-278" data-mp="kk5jc3668ali">{context}</p>

      <div className="mt-4" data-id="element-279" data-mp="fp02hirmlm4a">
        <AnswerRecap lead={ratingResult.yourLead} value={`${value} / 5`} data-id="element-280" data-mp="fllyk63bd4uq" />
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      delay: 0.06,
      ease: EASE
    }} className="mt-3 rounded-xl border border-line bg-mist px-4 py-4" data-id="element-281" data-mp="aqgc96601o64">
        <p className="text-[9px] uppercase tracking-micro text-mut" data-id="element-282" data-mp="3r7pgo46j6kvu">{ratingResult.averageLead}</p>
        <p className="mt-1.5 font-display text-[34px] font-bold leading-none tabular-nums text-blue" data-id="element-283" data-mp="3cit722otszt4">
          {average}
          <span className="ml-1 font-display text-[16px] font-semibold text-navy2" data-id="element-284" data-mp="3hi5v2qrfocxa">/ 5</span>
        </p>
        <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-line" data-id="element-285" data-mp="92vvbpb0njso">
          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: Number(average) / 5
        }} transition={{
          duration: 0.28,
          delay: 0.12,
          ease: EASE
        }} style={{
          transformOrigin: 'left'
        }} className="h-full bg-blue" data-id="element-286" data-mp="e0xcg4ovt91i" />
        </div>
        <p className="mt-3 text-[12px] leading-snug text-navy2" data-id="element-287" data-mp="2jtcjpjg2c93r">
          <span className="font-semibold tabular-nums text-navy" data-id="element-288" data-mp="2jvynr93qw6h8">{highPct}%</span>{' '}
          {ratingResult.highNote}
        </p>
      </motion.div>

      <motion.p initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.22,
      delay: 0.14,
      ease: EASE
    }} className="mt-3 text-[12.5px] leading-relaxed text-navy" data-id="element-289" data-mp="v8ol2aq0r6s3">
        {ratingAlignmentNote(value, Number(average), highPct)}
      </motion.p>

      <p className="mt-auto pt-6 text-[10.5px] leading-snug text-mut" data-id="element-290" data-mp="gkkaxv5183kx">
        Based on {tally.n} NOK delegates so far.
      </p>
    </div>;
}